import { render, staticRenderFns } from "./ResultPopup.vue?vue&type=template&id=421b84fc&scoped=true"
import script from "./ResultPopup.vue?vue&type=script&lang=js"
export * from "./ResultPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421b84fc",
  null
  
)

export default component.exports